var t;!function(t){t.custom="CUSTOM",t.default="DEFAULT"}(t||(t={}));export{t as Variations};
